import { useMemo } from "react";
import { useAuth } from "react-oidc-context";

import { type CurrentUserIdentity, currentUserIdentityFromProfile } from "../model/current-user-identity";

export function useCurrentUserIdentity(): CurrentUserIdentity {
  const auth = useAuth();
  const profile = auth?.user?.profile;
  return useMemo(() => currentUserIdentityFromProfile(profile), [profile]);
}
